import {OdAndOsType} from '@optimaxdev/design-system/dist/types/components/prescriptionTable/types';

import {PrescriptionTypeFilterIds} from 'constants/contactLenses';
import {PrescriptionType} from 'desktop/types/checkoutItemsType';
import {getDnForEye} from 'libs/utils/getDnForEye/getDnForEye';

export const PRESCRIPTION_FIELDS_BY_TYPE_ID = {
    [PrescriptionTypeFilterIds.MULTIFOCAL]: ['sph', 'bc', 'dia', 'add'],
    [PrescriptionTypeFilterIds.MULTIFOCAL_TORIC]: ['sph', 'bc', 'dia', 'cyl', 'axi', 'add', 'dn'],
    [PrescriptionTypeFilterIds.SINGLE_VISION]: ['sph', 'bc', 'dia'],
    [PrescriptionTypeFilterIds.TORIC_ASTIGMATISM]: ['sph', 'bc', 'dia', 'cyl', 'axi'],
} as const;

const MULTIFOCAL_TORIC_FIELDS_WITHOUT_DN = ['sph', 'bc', 'dia', 'cyl', 'axi', 'add'] as const;

export const PRESCRIPTION_TYPE_IDS = [
    PrescriptionTypeFilterIds.MULTIFOCAL,
    PrescriptionTypeFilterIds.MULTIFOCAL_TORIC,
    PrescriptionTypeFilterIds.SINGLE_VISION,
    PrescriptionTypeFilterIds.TORIC_ASTIGMATISM,
] as const;

/**
 * returns prepared contact lens prescription for eye
 */
export const getPreparedCLPrescription = (
    prescription: PrescriptionType,
    prescriptionTypeId: Optional<number>,
    eyeLabel: 'os' | 'od',
) => {
    if (!prescriptionTypeId || !PRESCRIPTION_TYPE_IDS.some(el => el === prescriptionTypeId))
        return prescription[eyeLabel] as OdAndOsType;

    const typeId = prescriptionTypeId as (typeof PRESCRIPTION_TYPE_IDS)[number];
    const eye = eyeLabel === 'od' ? 'right' : 'left';
    const dnField = getDnForEye(prescription.dn, eye);

    const isSkipDnNeeded =
        typeId === PrescriptionTypeFilterIds.MULTIFOCAL_TORIC && dnField === 'None';

    const requiredPrescriptionFields = isSkipDnNeeded
        ? MULTIFOCAL_TORIC_FIELDS_WITHOUT_DN
        : PRESCRIPTION_FIELDS_BY_TYPE_ID[typeId];
    const preparedPrescriptionEntries = requiredPrescriptionFields.map(el => [
        el,
        el === 'dn' ? dnField : prescription[eyeLabel][el],
    ]);

    return Object.fromEntries(preparedPrescriptionEntries) as OdAndOsType;
};
